import { Color } from '@persona-id/design-tokens';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled, { css } from 'styled-components';

export type NavbarColorVariant = 'primary' | 'danger' | 'selected' | 'disabled';

export const NavbarItemContainer = styled.div<{ colorVariant: NavbarColorVariant }>`
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;

  border-radius: ${BORDER_RADIUSES.rounded};
  user-select: none;

  &:hover {
    cursor: pointer;
  }

  ${({ colorVariant }) => {
    switch (colorVariant) {
      case 'danger':
        return css`
          p {
            color: ${Color.TextDanger};
          }

          &:hover {
            background-color: ${Color.CoreRed100};
            p {
              color: ${Color.TextDanger};
            }
            svg {
              color: ${Color.TextDanger};
            }
          }
        `;
      case 'selected':
        return css`
          background-color: ${Color.CorePurple100};
          p {
            color: ${Color.TextActive};
          }

          &:hover {
            svg {
              color: ${Color.BorderIconActive};
            }
          }
        `;
      case 'disabled':
        return css`
          p {
            color: ${Color.TextDisabled};
          }
        `;
      case 'primary':
      default:
        return css`
          p {
            color: ${Color.TextPrimary};
          }

          &:hover {
            background-color: ${Color.CorePurple100};
            p {
              color: ${Color.TextActive};
            }
            svg {
              color: ${Color.BorderIconActive};
            }
          }
        `;
    }
  }}
`;

export const NavbarIcon = styled.div<{ colorVariant?: NavbarColorVariant }>`
  display: flex;
  align-items: center;

  svg {
    height: 16px;
    width: 16px;
    color: ${({ colorVariant }) => {
      switch (colorVariant) {
        case 'selected':
          return Color.BorderIconActive;
        case 'danger':
          return Color.TextDanger;
        case 'disabled':
          return Color.TextDisabled;
        case 'primary':
        default:
          return Color.BorderIconSecondary;
      }
    }};
  }
`;
